import React from "react";
import { STATS } from "../../mock";
import CountUp from "../CountUp";

export default function Stats() {
  return (
    <section className="bg-white py-16 sm:py-20 border-b border-[#eef1f4]">
      <div className="container-x">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {STATS.map((s, i) => (
            <div key={s.label} className={`reveal delay-${i + 1} text-center lg:text-left`}>
              <CountUp value={s.value} className="block font-display text-4xl sm:text-5xl font-bold text-[#0f2740] mb-3" data-testid={`stat-value-${i}`} />
              <div className="h-px w-16 bg-[#2f9fe6] mb-3 mx-auto lg:mx-0" />
              <div className="text-[#2f9fe6] tracking-[0.18em] text-xs sm:text-sm font-medium uppercase">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
